import { request } from "./client";
import { registerMessages } from "./errors";

registerMessages({
  "failed to list exercises": "Не удалось загрузить упражнения",
  "name and valid measurement_type required": "Укажите название и способ измерения",
  "failed to create exercise": "Не удалось добавить упражнение",
  "failed to update exercise": "Не удалось сохранить упражнение",
  "coach or admin only": "Недостаточно прав",
  "not assigned to this group": "Недостаточно прав",
  "date required": "Не указана дата",
  "failed to resolve player group": "Не удалось определить группу ребёнка",
  "failed to create test": "Не удалось создать сдачу",
  "group_id required": "Не выбрана группа",
  "failed to list tests": "Не удалось загрузить сдачи",
  "test not found": "Сдача не найдена",
  "failed to delete test": "Не удалось удалить сдачу",
  "failed to delete result": "Не удалось стереть результат",
  "value_primary must be >= 0": "Результат не может быть отрицательным",
  "attempts must be > 0": "Попыток должно быть больше нуля",
  "made cannot exceed attempts": "Попаданий не может быть больше, чем попыток",
  "failed to save result": "Не удалось сохранить результаты",
  "failed to reload test": "Результаты сохранены, но обновить сдачу не удалось",
});

export type MeasurementType = "count" | "made_of" | "time_distance";

export interface NormativeExercise {
  id: string;
  name: string;
  measurement_type: MeasurementType;
  unit_label: string;
  higher_is_better: boolean;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

// For made_of, value_primary is shots made and value_secondary is attempts.
export interface NormativeResult {
  id: string;
  test_id: string;
  player_id: string;
  exercise_id: string;
  value_primary: number;
  value_secondary: number | null;
  created_at: string;
  updated_at: string;
}

export interface NormativeTest {
  id: string;
  group_id: string | null;
  coach_id: number | null;
  date: string;
  title: string | null;
  created_at: string;
  updated_at: string;
  results?: NormativeResult[];
}

export interface ExerciseInput {
  name: string;
  measurement_type: MeasurementType;
  unit_label: string;
  higher_is_better: boolean;
  sort_order: number;
}

// value_primary null erases the cell.
export interface ResultInput {
  player_id: string;
  exercise_id: string;
  value_primary: number | null;
  value_secondary: number | null;
}

export const normativesApi = {
  listExercises: () => request<NormativeExercise[] | null>("/api/normatives/exercises?all=true"),

  createExercise: (input: ExerciseInput) =>
    request<NormativeExercise>("/api/normatives/exercises", { method: "POST", body: JSON.stringify(input) }),

  // The server changes only the fields sent.
  updateExercise: (
    id: string,
    changes: Partial<Omit<ExerciseInput, "measurement_type">> & { is_active?: boolean },
  ) =>
    request<NormativeExercise>(`/api/normatives/exercises/${encodeURIComponent(id)}`, {
      method: "PUT",
      body: JSON.stringify(changes),
    }),

  listTests: (groupID: string) =>
    request<NormativeTest[] | null>(`/api/normatives/tests?${new URLSearchParams({ group_id: groupID })}`),

  getTest: (id: string) => request<NormativeTest>(`/api/normatives/tests/${encodeURIComponent(id)}`),

  createTest: (input: { group_id: string; date: string; title: string | null }) =>
    request<NormativeTest>("/api/normatives/tests", { method: "POST", body: JSON.stringify(input) }),

  // Every child with a saved value gets a push, and so do their parents.
  saveResults: (id: string, results: ResultInput[]) =>
    request<NormativeTest>(`/api/normatives/tests/${encodeURIComponent(id)}/results`, {
      method: "PUT",
      body: JSON.stringify({ results }),
    }),

  deleteTest: (id: string) =>
    request<void>(`/api/normatives/tests/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
